import type { QuestionnaireRevisionContext } from '@gcv/shared';

export const getLatestRevision = (
  history: QuestionnaireRevisionContext[] | undefined
): QuestionnaireRevisionContext | undefined => {
  if (!history?.length) return undefined;
  return history.reduce(
    (acc, entry) => (entry.revision_number > acc.revision_number ? entry : acc),
    history[0]
  );
};
